import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";

const InvoiceregisterEdit = () => {
  const [invoicedate, setInvoicedate] = useState("");
  const [client, setClient] = useState("");
  const [invoiceno, setInvoiceno] = useState("");
  const [invoicedamount, setInvoicedamount] = useState("");
  const [amountpaid, setAmountpaid] = useState("");
  const [balanceamount, setBalanceamount] = useState("");
  const [invoicetype, setInvoicetype] = useState("");
  const [redirect, setRedirect] = useState(false);
  const ref = useRef < HTMLInputElement > null;

  let { id } = useParams();
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`invoiceregister/${id}`);
      setInvoicedate(data.invoicedate);
      setClient(data.client);
      setInvoiceno(data.invoiceno);
      setInvoicedamount(data.invoicedamount);
      setAmountpaid(data.amountpaid);
      setBalanceamount(data.balanceamount);
      setInvoicetype(data.invoicetype);
    })();
  }, [id]);
  const submit = async (e) => {
    e.preventDefault();
    const { data } = await axios.put(`invoiceregister/${id}`, {
      invoicedate,
      client,
      invoiceno,
      invoicedamount,
      amountpaid,
      balanceamount,
      invoicetype,
    });
    console.log(data);
    setRedirect(true);
  };

  if (redirect) {
    return <Navigate to={"/invoiceregister"} />;
  }
  return (
    <Wrapper pageTitle={"Edit Invoiceregister"}>
      <InnerNav
        createLink={"/invoiceregisterCreate"}
        listLink={"/invoiceregister"}
      />
      <form onSubmit={submit}>
        <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Invoicedate{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Invoicedate"
              value={invoicedate}
              onChange={(e) => setInvoicedate(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Client </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Client"
              value={client}
              onChange={(e) => setClient(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Invoiceno </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Invoiceno"
              value={invoiceno}
              onChange={(e) => setInvoiceno(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Invoicedamount{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Invoicedamount"
              value={invoicedamount}
              onChange={(e) => setInvoicedamount(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Amountpaid{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Amountpaid"
              value={amountpaid}
              onChange={(e) => setAmountpaid(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Balanceamount{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Balanceamount"
              value={balanceamount}
              onChange={(e) => setBalanceamount(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Invoicetype{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Invoicetype"
              value={invoicetype}
              onChange={(e) => setInvoicetype(e.target.value)}
            />
          </label>

          <div className="flex mt-6 text-sm">
            <label className="flex items-center dark:text-gray-400">
              <button
                className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                onClick={submit}
              >
                {" "}
                <FiSave /> <span className="ml-3">Save</span>{" "}
              </button>
            </label>
          </div>
        </div>
      </form>
    </Wrapper>
  );
};
export default InvoiceregisterEdit;
